// src/services/firestoreService.js
import { doc, setDoc } from "firebase/firestore";
import { db } from "./firebase.js";
import { logger } from "../utils/logger";

/**
 * @file This service provides a function for setting the user's favorite team in Firestore.
 */

/**
 * Sets the user's favorite team in Firestore.
 *
 * @param {string} uid - The user's ID.
 * @param {string} teamId - The ID of the team to set as favorite.
 * @returns {Promise<void>} A promise that resolves when the favorite team is set.
 */
export const setUserFavoriteTeam = async (uid, teamId) => {
  if (!uid) {
    logger.warn("firestoreService: setUserFavoriteTeam called without a UID.");
    return;
  }
  logger.log(`firestoreService: Setting favorite team for UID: ${uid}`, { teamId });
  const userDocRef = doc(db, 'users', uid);
  await setDoc(userDocRef, { favoriteTeamId: teamId }, { merge: true });
};
